import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'
import { isDefined, isEmailAddress } from '@mntn-dev/utilities'

export function billingProfileHasValidContactEmail(
  billingProfile: BillingProfileDomainQueryModel
) {
  return (
    isDefined(billingProfile.billingContactEmail) &&
    isEmailAddress(billingProfile.billingContactEmail)
  )
}
